module.exports = __webpack_public_path__ + "img/showcase.230db0e9.svg";